<template>
    <div v-if="loading" class="accessible-loader">
        <!-- Circular Progress -->
        <v-card v-if="type === 'circular'" class="pa-4">
            <div class="d-flex flex-column align-center">
                <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
                <div class="loading-text mt-4">{{ message }}</div>
            </div>
        </v-card>

        <!-- Linear Progress -->
        <v-card v-else-if="type === 'linear'" class="pa-4">
            <div class="text-center mb-4 loading-text">{{ message }}</div>
            <v-progress-linear color="primary" indeterminate height="6"></v-progress-linear>
        </v-card>

        <!-- Skeleton Loader -->
        <v-card v-else-if="type === 'skeleton'" class="pa-4">
            <div class="text-center mb-4 loading-text">{{ message }}</div>
            <v-skeleton-loader type="article"></v-skeleton-loader>
        </v-card>

        <!-- Dots Loading -->
        <v-card v-else-if="type === 'dots'" class="pa-4">
            <div class="d-flex flex-column align-center">
                <div class="dots-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="loading-text mt-4">{{ message }}</div>
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'circular',
            validator: value => ['circular', 'linear', 'skeleton', 'dots'].includes(value)
        },
        message: {
            type: String,
            default: 'Veuillez patienter pendant que nous traitons votre demande...'
        },
        loading: {
            type: Boolean,
            required: true
        }
    }
}
</script>

<style scoped>
.loading-text {
    font-size: 1.5rem;
    color: inherit;
    font-weight: 500;
    text-align: center;
}

.dots-loader {
    display: flex;
    gap: 8px;
    padding: 20px;
}

.dots-loader span {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: currentColor;
    opacity: 0.6;
    animation: dots-fade 1.5s ease-in-out infinite;
}

.dots-loader span:nth-child(2) {
    animation-delay: 0.5s;
}

.dots-loader span:nth-child(3) {
    animation-delay: 1s;
}

@keyframes dots-fade {

    0%,
    100% {
        opacity: 0.3;
        transform: scale(0.8);
    }

    50% {
        opacity: 1;
        transform: scale(1);
    }
}


</style>

<style>
.accessible-loader .v-card {
    background-color: var(--v-theme-surface);
}

.accessible-loader .v-progress-circular,
.accessible-loader .v-progress-linear {
    --v-theme-primary: var(--v-theme-primary, #1976d2);
}
</style>
